import { render, staticRenderFns } from "./competitionDownload.vue?vue&type=template&id=0825041e&scoped=true&"
import script from "./competitionDownload.vue?vue&type=script&lang=ts&"
export * from "./competitionDownload.vue?vue&type=script&lang=ts&"
import style0 from "./competitionDownload.vue?vue&type=style&index=0&id=0825041e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825041e",
  null
  
)

export default component.exports